import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
const Companions = ({ data, tabHeight }) => {


    return (
        <Box
            sx={{
                height: `calc(100vh - ${tabHeight})`,
                paddingTop: '5px',
                boxSizing: 'border-box',
                overflowY: 'auto',
                p: 1
            }}
        >

            <Paper elevation={3} sx={{ padding: 2, marginBottom: 2 }}>
                <Typography>
                    You currently have no companions.
                </Typography>
            </Paper>
        </Box>
    );
};

export default Companions;
